import { FC } from 'react';

import { LeaderboardReward } from '@wwe-portal/entities/rbe.type';
import { RewardItem } from './reward-item';

const BaseLeaderboardRewardList: FC<{
  rewards: Partial<LeaderboardReward>[];
  containerClassName: string | undefined;
}> = ({ rewards, containerClassName }) => {
  return (
    <div className={containerClassName}>
      {rewards?.map((reward, index) => {
        return (
          <div key={index} className="flex flex-col">
            <RewardItem rewardItem={reward} />
            <span className="text-center text-xs">
              x{reward?.rewardQuantity}
            </span>
          </div>
        );
      })}
    </div>
  );
};

export const LeaderboardRewards: FC<{
  rewards: Partial<LeaderboardReward>[];
}> = ({ rewards }) => {
  return (
    <BaseLeaderboardRewardList
      rewards={rewards}
      containerClassName={
        'overflow-x-auto flex flex-row-reverse gap-x-[5px] justify-start pt-2 max-w-[160px] md:justify-center md:gap-x-4 md:max-w-full'
      }
    />
  );
};
